








































































































































































import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import { each, isInteger } from 'lodash'
import { camelizeKeys } from '@/utils'

import Process from '@/components/workflow/Process.vue'
import Task from '@/components/workflow/Task'
import Measures from '@/survey/Measures.vue'
import Steps from '@/survey/elements/Steps.vue'
import { kebabToCamelCase } from '@/utils'
import AssessmentMixin from './AssessmentMixin'

export default mixins(AssessmentMixin).extend({
  components: {
    Cdrisk10: require('@/survey/measures/cdrisk10/CD-Risk10.vue').default,
    CounselingQuestions: require('@/survey/measures/counselingQuestions/CounselingQuestions.vue')
      .default,
    Eurohis: require('@/survey/measures/eurohis/Eurohis.vue').default,
    Measures,
    Phq4: require('@/survey/measures/phq4/Phq4.vue').default,
    Sbqr: require('@/survey/measures/suicidal_ideation_and_behaviour/Suicidal_Ideation.vue')
      .default,
    Process,
    Steps,
    Task,
  },
  data() {
    const ymlDemographics: any = require('@/survey/measures/demographics/01-demographics.yml')
    const ymlInternetAffinity: any = require('@/survey/measures/demographics/08-internet-affinity.yml')
    //const yml_loss: any = require('@/survey/measures/demographics/06-loss.yml')

    const demographics: any = kebabToCamelCase(ymlDemographics)
    const internetAffinity: any = kebabToCamelCase(ymlInternetAffinity)
    //const loss: any = kebabToCamelCase(yml_loss)

    return {
      questions: {
        demographics,
        //loss,
        internetAffinity,
      },
    }
  },
})
